import React, { createContext, useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { flatMap } from '../../../../Util';
import SystemServices from '../../../../Services/SystemServices';
import EventTrackingServices from '../../../../Services/EventTrackingServices';
import ImpersonatingServices from '../../../../Services/ImpersonatingServices';
import AccountTenantServices from '../../../../Services/AccountTenantServices';
import SetupAccountServices from '../../../../Services/SetupAccountServices';
import SearchProductFeedServices from '../../../../Services/SearchProductFeed';
import {
	capitalizeFirstLetter,
	getProductsReplaceInTransformationObject,
	filterJustByReplaceProduct,
	getProductsWhithoutReplaceTransformationObject,
	replaceId,
	demoteId,
	promoteId
} from '../utils';

import { crudEmerchRanking } from '../api/CrudEmerchRanking';
import { usedataProcessing } from '../api/dataProcessing';
import { exampleRule } from '../typeRanking';
import ShopifyManualSortingServices, { ShopifyCollectionManualProductPosition, ShopifyProductCollection } from '../../../../Services/ShopifyManualSortingServices';
import { PinnedShopifyProduct, ShopifyCollectionWithPinnedProducts, toShopifyCollectionManualProductPosition } from '../../UI/ManualSorting/ShopifySorting/ShopifyManualSortingTypes';
import { ProductFields, ProductRequestResult, ProductRequestResultProduct, SearchRequest } from '../../../../Services/SearchProductFeedTypes';
import ShopifyCollectionPinnedProductsService, { ShopifyCollectionPinnedProductsServiceType } from '../services/ShopifyCollectionPinnedProductsService';

export type NameLabel = {
	name?: string;
	label: string;
	value?: string;
};

type RankingContextType = {
	selectedProducts: any;
	setSelectedProducts:any;
	errorNoConfiguration: boolean;
	deviceType: string;
	changeDeviceSelected: (deviceName: string) => void;
	accountWithoutCategories: boolean;
	idInClipBoard: string;
	copyToClipBoard: (value: string) => void;
	loadingSaving: boolean;
	checkIfCanQuitWithoutSave: () => void;
	modalConfirmIsOpen: boolean;
	returnToDashboard: () => void;
	handleCloseConfirm: () => void;
	modalCancelActions: boolean;
	cancelActions: () => void;
	handleCloseCancelActions: () => void;
	returnToFirstStateOfRanking: () => void;
	handleChangeTenantPreview: (target: string) => void;
	previewTenant: NameLabel | undefined;
	mode: 'creation' | 'edition';
	tenantsCatalog: NameLabel[];
	ruleName: string;
	rankingObject: RankingObject;
	handleChangeRankingName: (target: string) => void;
	handleChangeRankingDescription: (target: string) => void;
	descriptionRule: string;
	handleChangeTenant: (target: string) => void;
	listTenantAccount: NameLabel[];
	ListFilter: any;
	handeChangeFilterSorting: (target: NameLabel) => void;
	updapteAttribute: (Collation: any, target: string) => void;
	removeAttribute: (isTag: boolean, target: any) => void;
	onChangeAttributeOfSign: (Collation: any) => void;
	onRemoveGroupSorting: () => void;
	onSetGroupSorting: (groupSorting: any) => void;
	getCheckIfIsAValidUrlFetch: (url: string) => void;
	productList: Product[];
	modalManualSorting: boolean;
	setModalManualIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	categorySelected: NameLabel | undefined;
	typeCategories: NameLabel[] | undefined;
	changeCategorySelected: (elem: string) => void;
	typeCategoriesSecondLevel: NameLabel[];
	typeCategoriesSecondLevelSelected: NameLabel | undefined;
	changeSecondCategorySelected: (elem: string) => void;
	handleSelectCategorySelection: (elem: any) => void;
	promotedProducts: PromotedProducts;
	demotedProduct: PromotedProducts;
	changeOrderOfPromotedProduct: (elem: any) => void;
	changeOrderOfDemotedProduct: (elem: any) => void;
	loadingProductList: boolean;
	addPromotedProductManualy: (newPromotedproducts: string) => void;
	deletePromotedProduct: (idsOfProduct: string[]) => void;
	addDemotedProductManualy: (newDemotedproducts: string) => void;
	deleteDemotedProduct: (idsOfProduct: string[]) => void;
	replaceProducts: Product[];
	deleteReplaceProductItem: (idsOfProduct: string[]) => void;
	addReplaceProductManualy: (promotedP: { replaceId: string; toReplaceId: string }) => void;
	addPromotedProductWithId: (newPromotedproductsId: string) => void;
	addPromotedProductsWithIds: (newPromotedproductsIds: string[]) => void;
	addDemotedProductIds: (newDemotedproductsIds: string[]) => void;
	addDemotedProductWithId: (newDemotedproductsId: string) => void;
	addReplaceProductWithId: (promotedP: { replaceId: string; toReplaceId: string }) => void;
	addReplaceProductWithIds: (promotedP: string[]) => void;
	paginationOptions: PaginationOptions;
	handleChangePaginationOptions: (elemName: keyof PaginationOptions, elemValue: number) => void;
	currentPageProductList: number;
	setCurrentPageProductList: React.Dispatch<React.SetStateAction<number>>;
	setNewPaginationNeed: React.Dispatch<React.SetStateAction<boolean>>;
	CreateRanking: () => void;
	PutRankingById: () => void;
	handleChangeSortingFactors: (target: any, add: boolean) => void;
	accountId: string;
	setupAccountServices: SetupAccountServices;
	searchProductFeed: SearchProductFeedServices;
	searchProducts: (search: SearchRequest, callbackSuccess: ((data: ProductRequestResult) => void), callbackError?: ((error: string) => void)) => void,
	searchProductsByIds: (ids: string[], callbackSuccess: ((data: ProductRequestResult) => void), callbackError?: ((error: string) => void)) => void,
	searchProductsByTerm: (searchTerm: string, callbackSuccess: ((data: ProductRequestResult) => void), callbackError?: ((error: string) => void)) => void,
	arrayOfValuetags: { id: string;[key: string]: any }[];
	applyManualTransformations: (First: string[], second: string[], third: { replaceId: string, toReplaceId: string }[]) => void;
	needToLoadPromote: boolean;
	setNeedToLoadPromote: React.Dispatch<React.SetStateAction<boolean>>;
	needToLoadDemote: boolean;
	setNeedToLoadDemote: React.Dispatch<React.SetStateAction<boolean>>;
	localArrayOfProductIdSwap: any;
	setLocalArrayOfProductIdSwap: React.Dispatch<React.SetStateAction<any>>;
	needToLoadSwap: boolean;
	setNeedToLoadSwap: React.Dispatch<React.SetStateAction<boolean>>;
	isSwapList: boolean,
	setIsSwapList: React.Dispatch<React.SetStateAction<boolean>>;
	canUseShopifyManualSorting: boolean;
	shopifyCollectionWithPinnedProducts: ShopifyCollectionWithPinnedProducts[] | undefined,
	shopifyPinnedProductsOfSelectedCategory: PinnedShopifyProduct[] | undefined,
	shopifyCollections: ShopifyProductCollection[] | undefined,
	hasRetrievedNoShopifyCollection: boolean,
	selectedCategoryIsShopifyCollection: { isPinnableShopifyCollection: boolean, collectionId?: string },
	shopifyCollectionPinnedProductsService: ShopifyCollectionPinnedProductsServiceType;
	deleteReplaceProductWithId: (replaceId: string) => void;
	deletePinnedProductWithId: (productId: string) => void;
};


interface RankingsProviderProps {
	children: React.ReactNode;
	$http?: any;
	$rootScope?: any;
	$routeParams?: any;
	AuthServices?: any;
	$location?: any;
	$timeout?: any;
}

type PaginationOptions = {
	ppoffset: number;
	pplimit: number;
	poffset: number;
	plimit: number;
	dpoffset: number;
	dplimit: number;
};

type PromotedProducts = {
	totalCount: number;
	pageItems: any[];
};

type Product = {
	id: string;
	// Add other product properties as needed
};

type Transformation = {
	collationId: string;
	params: Array<{
		name: string;
		value: {
			stringValues: string[];
		};
	}>;
};

type RankingObject = {
	name: string;
	id?: string
	description: string;
	sorting: Array<{
		collationId: string;
		params: any[];
		period?: any;
		weight: number;
	}>;
	tenant?: string | null;
	transformations: Transformation[];
	groupSorting?: any;
	manualProductPositions?: ShopifyCollectionManualProductPosition[]
};

interface RankingsProviderProps {
	children: React.ReactNode;
	$http?: any
	$rootScope?: any
	$routeParams?: any
	AuthServices?: any
	$location?: any
	$timeout?: any
}
function getUniqueSortingFactors(arrayToFilter): any {
	const uniqueItem = arrayToFilter.reduce((acc, curr) => {
		if (curr.collationId ===
			'cfe9fc4b-ee69-4359-82ee-496f787d9414') {
			acc = [...acc, curr.params[0].value.stringValues[0]];
		}
		return acc;
	}, []);

	return [...new Set(uniqueItem)];
}
// @ts-ignore
const RankingContext = createContext<RankingContextType>();

function useRankingContext(): RankingContextType {
	const context = useContext(RankingContext);
	if (context === undefined) throw Error('useRankingContext can only be used inside a RankingsProvider');
	return context;
}

const CreateRankingContextProvider: React.FC<RankingsProviderProps> = (props) => {
	const $http = props.$http;
	const AuthServices = props.AuthServices;

	const $rootScope = props.$rootScope;
	const $routeParams = props.$routeParams;
	const $timeout = props.$timeout;
	const systemServices = new SystemServices($rootScope, $timeout);
	const impersonatingServices = new ImpersonatingServices(props.$rootScope, $routeParams);
	const impersonatedAccount = impersonatingServices.getImpersonatedAccount();
	const accountId = impersonatedAccount || props.$rootScope.User.Account.Key;

	const accountTenantServices = new AccountTenantServices(props.$http,
		AuthServices, accountId
	);
	const setupAccountServices = new SetupAccountServices(props.$http);
	const searchProductFeed = new SearchProductFeedServices(props.$http, AuthServices, accountId);
	const { trackEvent } = EventTrackingServices(props.$rootScope.User);

	const [serviceCache, setServiceCache] = useState({});

	const shopifyManualSortingServices = new ShopifyManualSortingServices($http, AuthServices, accountId, serviceCache, setServiceCache);

	const [mode, setMode] = useState<'creation' | 'edition'>('creation');
	const [accountWithoutCategories, setAccountWithoutCategories] = useState(false);
	const [originalRankingRule, setOriginalRankingRule] = useState<string | undefined>();
	const [modalConfirmIsOpen, setmodalConfirmIsOpen] = useState(false);
	const [modalCancelActions, setmodalCancelActions] = useState(false);
	const [modalManualSorting, setModalManualIsOpen] = useState(false);
	const [loadingProductList, setloadingProductList] = useState(true);
	const [loadingSaving, setloadingSaving] = useState(false);
	const [ruleName, setRuleName] = useState('New ranking rule');
	const [descriptionRule, setDescriptionRule] = useState('');
	const [rankingObject, setRankingObject] = useState<RankingObject>(exampleRule);
	const [deviceType, setdeviceType] = useState('Mobile');
	const [allCategoriesData, setallCategoriesData] = useState<any>();
	const [typeCategories, setTypeCategories] = useState<[] | undefined>();
	const [categorySelected, setCategorySelected] = useState<NameLabel | undefined>();
	const [typeCategoriesSecondLevel, settypeCategoriesSecondLevel] = useState<any>();
	const [typeCategoriesSecondLevelSelected, setTypeCategoriesSecondLevelSelected] = useState<NameLabel | undefined>();
	const [errorNoConfiguration, setErrorNoConfiguration] = useState(false);
	const [promotedProducts, setPromotedProducts] = useState<PromotedProducts>({totalCount: 0, pageItems: []});
	const [demotedProduct, setDemotedProduct] = useState<PromotedProducts>({totalCount: 0, pageItems: []});
	const [productList, setproductList] = useState([]);
	const [replaceProducts, setReplaceProducts] = useState([]);
	const [localArrayOfProductIdSwap, setLocalArrayOfProductIdSwap] = useState([]);
	const [ListFilter, setListFilter] = useState();
	const [listTenantAccount, setlistTenantAccount] = useState([{
		label: 'Default',
		value: ''
	}

	]);
	const [tenantsCatalog, setTenantsCatalog] = useState([]);

	const [previewTenant, setpreviewTenant] = useState<NameLabel | undefined>({
		label: 'Default',
		value: ''
	});

	const [idInClipBoard, setidInClipBoard] = useState('');

	const [newPaginationNeed, setNewPaginationNeed] = useState(false);
	const [needRefreshPagination, setneedRefreshPagination] = useState(false);

	const [currentPageProductList, setCurrentPageProductList] = useState(1);
	const [paginationOptions, setpaginationOptions] = useState({
		ppoffset: 0,
		pplimit: 40,
		poffset: 0,
		plimit: 20,
		dpoffset: 0,
		dplimit: 40
	});

	const [needToRefreshTenantCategory, setneedToRefreshTenantCategory] = useState(true);
	const [isFirstRender, setisFirstRender] = useState(true);
	const [arrayOfValuetags, setarrayOfValuetags] = useState([]);
	const [needToLoadPromote, setNeedToLoadPromote] = useState(true);
	const [needToLoadDemote, setNeedToLoadDemote] = useState(true);
	const [needToLoadSwap, setNeedToLoadSwap] = useState(true);
	const [isSwapList, setIsSwapList] = useState(false);

	const [selectedCategoryIsShopifyCollection, setSelectedCategoryIsShopifyCollection] = useState<{ isPinnableShopifyCollection: boolean, collectionId?: string }>({ isPinnableShopifyCollection: false });
	const [shopifyPinnedProductsOfSelectedCategory, setShopifyPinnedProductsOfSelectedCategory] = useState<PinnedShopifyProduct[] | undefined>(undefined);
	const [shopifyCollections, setShopifyCollections] = useState<ShopifyProductCollection[] | undefined>(undefined);
	const [shopifyCollectionWithPinnedProducts, setShopifyCollectionWithPinnedProducts] = useState<ShopifyCollectionWithPinnedProducts[] | undefined>(undefined);
	const [hasRetrievedNoShopifyCollection, setHasRetrievedNoShopifyCollection] = useState<boolean>(false);
	const [canUseShopifyManualSorting, setCanUseShopifyManualSorting] = useState<boolean>(false);

	const shopifyCollectionPinnedProductsService = ShopifyCollectionPinnedProductsService(setShopifyCollectionWithPinnedProducts);
	const [selectedProducts, setSelectedProducts] = useState<any>([]);
	const {
		getProductCollation,
		getProductFeedCategory,
		getRankingById,
		getPreview,
		createRanking,
		putRankingById,
		getCheckIfIsAValidUrlFetch
	} = crudEmerchRanking($http, $rootScope, $timeout, $routeParams, AuthServices, shopifyManualSortingServices);

	const {
		getTenant,
		sortByAsc
	} = usedataProcessing($http,
		accountId,
		setpreviewTenant,
		AuthServices,
		setlistTenantAccount
	);
	function resetPagination() {
		setpaginationOptions({
			ppoffset: 0,
			pplimit: 40,
			poffset: 0,
			plimit: 20,
			dpoffset: 0,
			dplimit: 40
		});
		setCurrentPageProductList(1);
	}
	const copyToClipBoard = (value) => {
		navigator.clipboard.writeText(value);
		setidInClipBoard(value);
	};
	function handleChangePaginationOptions(elemName, elemValue) {
		setpaginationOptions(pagination => ({
			...pagination,
			[elemName]: elemValue
		}));
	}
	let urlReturn = '/ProductSettings/Ranking';
	if ($routeParams && $routeParams.ka) {
		urlReturn += '?ka=' + $routeParams.ka;
	}

	const CreateRanking = () => {
		setloadingSaving(true);
		// Get new value for name of ranking
		const newRanking = {
			...rankingObject
		};
		if ((rankingObject.tenant == null && tenantsCatalog.length === 1) &&
			listTenantAccount.length > 0) {
			newRanking.tenant = '';
		}
		newRanking.name = ruleName;
		newRanking.description = descriptionRule;
		createRanking(newRanking,
			newData => {
				trackEvent('ranking/new-rule-saved');
				systemServices.showSuccess('Ranking created successfully !');
				let url = '/ProductSettings/Ranking/Setting?id=' + newData.id;
				if ($routeParams && $routeParams.ka) {
					url += '&ka=' + $routeParams.ka;
				}
				setTimeout(() => {
					window.location.href = url;
				}, 1000);
			},
			error => {
				console.log('err', error);
				setloadingSaving(false);
			});
	};
	const PutRankingById = () => {
		const newRanking = {
			...rankingObject
		};
		newRanking.name = ruleName;
		newRanking.description = descriptionRule;
		putRankingById(newRanking,
			rankingObject.id,
			_newData => {
				trackEvent('ranking/existing-rule-saved');
				systemServices.showSuccess('Changes successfully saved !');
				// change original ranking rule with new ranking data for the comparison
				setOriginalRankingRule(JSON.stringify(newRanking));
			},
			error => {
				console.log('err', error);
			});
	};
	const GetProductCollation = (cat = 'global') => getProductCollation(
		cat,
		newData => {
			setListFilter(newData);
		});
	function hasErrorNoConfiguration(data) {
		if (data.status == '404') {
			// systemServices.showError(data.data);
			setErrorNoConfiguration(true);
			setloadingProductList(false);
		} else {
			systemServices.showError();
			setloadingProductList(false);
		}
	}
	const getTenantsCatalogTenant = () => {
		accountTenantServices.getTenantsCatalogTenant(
			(tenantL) => {
				const listOfTenant = tenantL.map((tenant) => {
					if (tenant === '') {
						return { label: 'Default', value: tenant };
					} else {
						return { label: tenant, value: tenant };
					}
				});
				if (listOfTenant.length > 1) {
					listOfTenant.unshift({ label: 'All', value: null });
				}
				const listOfTenantSort = listOfTenant.sort(sortByAsc);
				setTenantsCatalog(listOfTenantSort);
				handleSelectMode(listOfTenantSort); // Ensure this is a function call
			},
			(_Error, errMessage) => {
				hasErrorNoConfiguration(errMessage);
			}
		);
	};
	function handleSelectMode(tenantsList) {
		// Check mode of editing of creating
		if ($routeParams && $routeParams.id !== undefined) {
			setMode('edition');
			setisFirstRender(false);
			trackEvent('ranking/existing-rule-opened');
			getRankingById($routeParams.id,
				newData => {
					setRankingObject(newData);
					loadShopifyCollectionWithPinnedProducts(newData.manualProductPositions);
					setRuleName(newData.name);
					setDescriptionRule(newData.description !== null ? newData.description : '');
					GetProductCollation();
					setReplaceProducts(getProductsReplaceInTransformationObject(newData.transformations));
					setOriginalRankingRule(JSON.stringify(newData));
					const tenantObj: any = {};
					tenantObj.listTenant = tenantsList;
					if (tenantsList) {
						tenantObj.tenantSelected = newData.tenant;
					}
					const arayOfValueTag = getUniqueSortingFactors(newData.sorting);
					setarrayOfValuetags(arayOfValueTag.map(x => ({ ...x, id: uuidv4() })));
					getProductFeedCategory(accountId,
						tenantObj,
						newData => {
							setneedToRefreshTenantCategory(false);
							// Get categories of product feed and transform object to list
							const backendCompleteObject: any = [...newData];
							if (backendCompleteObject.length === 0) {
								setAccountWithoutCategories(true);
								settypeCategoriesSecondLevel([{
									name: '',
									label: ''
								}]);
								setTypeCategoriesSecondLevelSelected(
									{
										name: '',
										label: ''
									}
								);
								setTypeCategories([]);
								setSelectedProducts([]);
								setCategorySelected({
									name: '',
									label: ''
								});
							}
							setallCategoriesData(backendCompleteObject);
							const arrayOfCategories = backendCompleteObject.map(el => ({ name: el.type, label: capitalizeFirstLetter(el.type) }));
							if (arrayOfCategories.length > 0) {
								setTypeCategories(arrayOfCategories);
								setCategorySelected(arrayOfCategories[0]);
								setSelectedProducts([]);
								// Transform list of second category
								const valueOfSecondCategorySelect = backendCompleteObject.find(el => el.type === arrayOfCategories[0].name).knownNames.map(el => ({ name: el, label: el }));
								settypeCategoriesSecondLevel(valueOfSecondCategorySelect);
								setTypeCategoriesSecondLevelSelected(valueOfSecondCategorySelect[0]);

							}
						});
				},
				_error => {
					// setRankingObject(rankingExample)
				}
			);
		} else if ($routeParams && $routeParams.id === undefined) {
			setMode('creation');
			setisFirstRender(false);
			trackEvent('ranking/new-rule-opened');
			GetProductCollation();
			shopifyManualSortingServices.getShopifyCollectionProductsManualPositions(
				manualProductPositions => loadShopifyCollectionWithPinnedProducts(manualProductPositions),
				error => console.log(error)
			);
			let tenant: string | null = null;
			const tenantObj: any = {};
			tenantObj.listTenant = tenantsList;
			const tenantsListFilter = tenantsList.filter(x => x.value !== null);
			if (tenantsListFilter.length !== 0) {

				tenantObj.tenantSelected = tenantsListFilter[0].value;
				tenant = tenantsListFilter[0].value;
			} else {
				tenantObj.tenantSelected = '';
				tenant = '';
			}
			const arayOfValueTag = getUniqueSortingFactors(rankingObject.sorting);
			setarrayOfValuetags(arayOfValueTag.map(x => ({ ...x, id: uuidv4() })));
			getProductFeedCategory(accountId,
				tenantObj,
				newData => {
					setneedToRefreshTenantCategory(false);
					// Get categories of product feed and transform object to list
					const backendCompleteObject: any = [...newData];
					if (backendCompleteObject.length === 0) {
						setAccountWithoutCategories(true);
						settypeCategoriesSecondLevel([{
							name: '',
							label: ''
						}]);
						setTypeCategoriesSecondLevelSelected(
							{
								name: '',
								label: ''
							}
						);
						setTypeCategories([]);
						setSelectedProducts([]);
						setCategorySelected({
							name: '',
							label: ''
						});
					}
					setallCategoriesData(backendCompleteObject);
					const arrayOfCategories = backendCompleteObject.map(el => ({ name: el.type, label: capitalizeFirstLetter(el.type) }));
					if (arrayOfCategories.length > 0) {
						setTypeCategories(arrayOfCategories);
						setCategorySelected(arrayOfCategories[0]);
						setSelectedProducts([]);
						// Transform list of second category
						const valueOfSecondCategorySelect = backendCompleteObject.find(el => el.type === arrayOfCategories[0].name).knownNames.map(el => ({ name: el, label: el }));
						settypeCategoriesSecondLevel(valueOfSecondCategorySelect);
						setTypeCategoriesSecondLevelSelected(valueOfSecondCategorySelect[0]);

					}
				});
			setRankingObject(r => ({
				...r, tenant: tenant
			}));
			setOriginalRankingRule(JSON.stringify({
				'name': 'New ranking rule',
				description: '',
				'sorting': [
				],
				'tenant': tenant,
				'transformations': [

				]
			}));
		}
	}
	function changeDeviceSelected(deviceName) {
		setdeviceType(deviceName);
		setneedRefreshPagination(true);
	}

	const getShopifyConfig = () => {
		shopifyManualSortingServices.canUseShopifyManualSorting(setCanUseShopifyManualSorting, error => console.log(error));
	};

	const loadShopifyCollectionWithPinnedProducts = (manualProductPosition: ShopifyCollectionManualProductPosition[] | undefined) => {
		const showAndLogError = (error: string, message: string) => {
			systemServices.showError(message);
			console.log(error);
		};

		function toPinnedProductCollection(collectionProductPosition: ShopifyCollectionManualProductPosition, products: ProductRequestResultProduct[], collections: ShopifyProductCollection[] | undefined): ShopifyCollectionWithPinnedProducts {
			const collection = collections?.find(x => x.id === collectionProductPosition.collectionId);
			const pinnedProducts = collectionProductPosition.productPositions.map<PinnedShopifyProduct>(p => ({
				position: p.position, product: products.find(i => i.id === p.productId) ?? { id: p.productId, name: p.productId + ' (Not found)' }
			}));

			return { collectionId: collectionProductPosition.collectionId, label: collection?.handle ?? collectionProductPosition.collectionId + ' (Not found)', pinnedProducts: pinnedProducts };
		}

		if (!manualProductPosition) return;

		shopifyManualSortingServices.getAvailableShopifyCollectionInfos(
			collections => {
				setShopifyCollections(collections);
				setHasRetrievedNoShopifyCollection(collections.length === 0);

				const ids = flatMap(manualProductPosition, x => x.productPositions.map(p => p.productId));
				searchProductsByIds(ids, searchResult => {
					setShopifyCollectionWithPinnedProducts(manualProductPosition.map(p => toPinnedProductCollection(p, searchResult.products, collections)));
				});

			},
			error => {
				showAndLogError(error, 'Cannot get Shopify collections');
			}
		);
	};

	useEffect(() => {
		getTenant();
		getTenantsCatalogTenant();
		getShopifyConfig();
	}, []);

	useEffect(() => {
		if (needToRefreshTenantCategory && !isFirstRender) {
			const tenantObj: any = {};
			tenantObj.tenantSelected = rankingObject.tenant;
			tenantObj.listTenant = tenantsCatalog;
			getProductFeedCategory(accountId,
				tenantObj,
				newData => {
					setneedToRefreshTenantCategory(false);
					// Get categories of product feed and transform object to list
					const backendCompleteObject: any = [...newData];
					if (backendCompleteObject.length === 0) {
						setAccountWithoutCategories(true);
						settypeCategoriesSecondLevel([{
							name: '',
							label: ''
						}]);
						setTypeCategoriesSecondLevelSelected(
							{
								name: '',
								label: ''
							}
						);
						setTypeCategories([]);
						setSelectedProducts([]);
						setCategorySelected({
							name: '',
							label: ''
						});
					}
					setallCategoriesData(backendCompleteObject);
					const arrayOfCategories = backendCompleteObject.map(el => ({ name: el.type, label: capitalizeFirstLetter(el.type) }));
					if (arrayOfCategories.length > 0) {
						setTypeCategories(arrayOfCategories);
						setCategorySelected(arrayOfCategories[0]);
						setSelectedProducts([]);
						// Transform list of second category
						const valueOfSecondCategorySelect = backendCompleteObject.find(el => el.type === arrayOfCategories[0].name).knownNames.map(el => ({ name: el, label: el }));
						settypeCategoriesSecondLevel(valueOfSecondCategorySelect);
						setTypeCategoriesSecondLevelSelected(valueOfSecondCategorySelect[0]);

					}

				});
		}
	}, [tenantsCatalog, needToRefreshTenantCategory]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setloadingProductList(true);
			setCurrentPageProductList(1);
			// getProducts With the preview API
			if (categorySelected &&
				typeCategoriesSecondLevelSelected) {
				const optionsObject: any = {
					// deviceType: deviceType,
				};
				if (!accountWithoutCategories) {
					optionsObject['categoryType'] = categorySelected.name;
					optionsObject['categoryName'] = typeCategoriesSecondLevelSelected.name;
				}

				const shouldNotUsePreviewTenant = rankingObject.tenant !== null && tenantsCatalog.length > 1;
				if (!shouldNotUsePreviewTenant) {
					optionsObject['previewTenant'] = previewTenant?.value;
				}
				getPreview(
					optionsObject,
					needRefreshPagination ? {
						ppoffset: 0,
						pplimit: 40,
						poffset: 0,
						plimit: 20,
						dpoffset: 0,
						dplimit: 40
					} : paginationOptions,
					rankingObject,
					newData => {
						setloadingProductList(false);
						setproductList(newData.products);
						setDemotedProduct(newData.demotedProducts);
						setPromotedProducts(newData.promotedProducts);
						needRefreshPagination && resetPagination();
						setneedRefreshPagination(false);
						// setidInClipBoard('')
					},
					_error => {
						setloadingProductList(false);
						setneedRefreshPagination(false);
						setproductList([]);
						setDemotedProduct({totalCount: 0, pageItems: []});
						setPromotedProducts({totalCount: 0, pageItems: []});
					});
			}
		}, 1500);

		return () => clearTimeout(timer);

	}, [rankingObject,
		categorySelected,
		typeCategoriesSecondLevelSelected,
		previewTenant,
		deviceType,
	]);

	useEffect(() => {		
		setRankingObject(x => ({
			...x, manualProductPositions: shopifyCollectionWithPinnedProducts?.map(toShopifyCollectionManualProductPosition)
		}));
	}, [shopifyCollectionWithPinnedProducts]);

	useEffect(() => {
		const shopifyCollection =
			shopifyCollections !== undefined && categorySelected?.name === 'collection'
				? shopifyCollections.find(x => x.handle == typeCategoriesSecondLevelSelected?.name) : undefined;
		setSelectedCategoryIsShopifyCollection({ isPinnableShopifyCollection: shopifyCollection !== undefined && canUseShopifyManualSorting, collectionId: shopifyCollection?.id });
		setShopifyPinnedProductsOfSelectedCategory(shopifyCollectionWithPinnedProducts?.find(c => c.collectionId === shopifyCollection?.id)?.pinnedProducts);
	}, [categorySelected, shopifyCollections, typeCategoriesSecondLevelSelected, shopifyCollectionWithPinnedProducts, canUseShopifyManualSorting]);

	useEffect(() => {
		if (newPaginationNeed) {
			setloadingProductList(true);
			if (categorySelected &&
				typeCategoriesSecondLevelSelected) {
				const optionsObject: any = {
					// deviceType: deviceType,
				};
				if (!accountWithoutCategories) {
					optionsObject['categoryType'] = categorySelected.name;
					optionsObject['categoryName'] = typeCategoriesSecondLevelSelected.name;
				}

				const shouldNotUsePreviewTenant = rankingObject.tenant !== null && tenantsCatalog.length > 1;
				if (!shouldNotUsePreviewTenant) {
					optionsObject['previewTenant'] = previewTenant?.value;
				}
				getPreview(
					optionsObject,
					paginationOptions,
					rankingObject,
					newData => {
						setloadingProductList(false);
						setproductList(newData.products);
						setDemotedProduct(newData.demotedProducts);
						setPromotedProducts(newData.promotedProducts);
						setNewPaginationNeed(false);
						// setidInClipBoard('')
					},
					_error => {
						setloadingProductList(false);
						setNewPaginationNeed(false);
						setproductList([]);
						setDemotedProduct({totalCount: 0, pageItems: []});
						setPromotedProducts({totalCount: 0, pageItems: []});
					});
			}
		}
	}, [paginationOptions]);

	function checkIfCanQuitWithoutSave() {
		const stringifyNewObj = { ...rankingObject };
		stringifyNewObj.name = ruleName;
		stringifyNewObj.description = descriptionRule;
		const compareIfIsSave = originalRankingRule === JSON.stringify(stringifyNewObj);

		if (compareIfIsSave) {
			window.location.href = urlReturn;
		} else {
			setmodalConfirmIsOpen(true);
		}
	}
	function cancelActions() {
		const stringifyNewObj = { ...rankingObject };
		stringifyNewObj.name = ruleName;
		stringifyNewObj.description = descriptionRule;
		const compareIfIsSave = originalRankingRule === JSON.stringify(stringifyNewObj);

		if (compareIfIsSave) {
			return;
		} else {
			setmodalCancelActions(true);
		}
	}
	function returnToDashboard() {
		window.location.href = urlReturn;
	}
	function handleCloseConfirm() {
		setmodalConfirmIsOpen(false);
	}
	function handleCloseCancelActions() {
		setmodalCancelActions(false);
	}
	function returnToFirstStateOfRanking() {
		const parseOriginalRankingRule = originalRankingRule ? JSON.parse(originalRankingRule) : {};
		setRuleName(parseOriginalRankingRule.name);
		setDescriptionRule(parseOriginalRankingRule.description !== null ? parseOriginalRankingRule.description : '');
		setRankingObject(parseOriginalRankingRule);
		handleCloseCancelActions();
	}
	// Change ranking object
	function handleChangeRankingName(target) {
		setRuleName(target);
	}
	function handleChangeRankingDescription(target) {
		setDescriptionRule(target);
	}
	function handleChangeTenant(target) {
		const targetIsDefault = target === '';
		const targetIsAll = target === 'All' || target === null;
		// @ts-ignore
		const newTenant = targetIsDefault ? '' : targetIsAll ? null : tenantsCatalog.find(el => el.label === target).value;
		setneedToRefreshTenantCategory(true);
		setRankingObject((ranking) => ({
			...ranking, tenant: newTenant
		}));
	}
	function handleChangeTenantPreview(target) {
		const newTenant: NameLabel | undefined = listTenantAccount.find(el => el.value == target);
		setpreviewTenant(newTenant);
	}
	// Sorting Tag
	function handleChangeSortingFactors(target, add) {
		// @ts-ignore
		const filterToAdd = Object.fromEntries(
			Object.entries({
				collationId: target.collationId,
				params: target.params,
				period: target.period,
				weight: -target.weight
			}).filter(([key, value]) => key !== 'period' || value !== null)
		);
		const newSorting = add ? [...rankingObject.sorting, filterToAdd] : rankingObject.sorting.map(x => x.collationId === filterToAdd.collationId ? filterToAdd : x);
		const arayOfValueTag = getUniqueSortingFactors(newSorting);
		setarrayOfValuetags(arayOfValueTag);
		// @ts-ignore
		setRankingObject((ranking) => ({
			...ranking,
			sorting: newSorting.filter(
				(item): item is { collationId: string; params: any[]; period?: any; weight: number } =>
					typeof item === 'object' &&
					item !== null &&
					typeof item.collationId === 'string' &&
					Array.isArray(item.params) &&
					typeof item.weight === 'number'
			),
		}));
	}

	// Group Sorting
	function onRemoveGroupSorting() {
		setRankingObject((ranking) => ({
			...ranking,
			groupSorting: null
		}));
	}

	function onSetGroupSorting(groupSorting) {
		setRankingObject((ranking) => ({
			...ranking,
			groupSorting: groupSorting
		}));
	}

	// Sorting factors
	function handeChangeFilterSorting(target) {
		if (!target) {
			return;
		}
		const newCollation = {
			collationId: target.id,
			weight: -0.5
		};
		const newObjectOfSorting = [...rankingObject.sorting, newCollation];
		// @ts-ignore
		setRankingObject((ranking) => ({
			...ranking, sorting: newObjectOfSorting
		}));
	}
	function removeAttribute(isTag, target) {
		if (isTag) {
			const indexOfItem = rankingObject.sorting.indexOf(target);
			const newSorting = [...rankingObject.sorting];
			newSorting.splice(indexOfItem, 1);
			const arayOfValueTag = getUniqueSortingFactors(newSorting);
			setarrayOfValuetags(arayOfValueTag);
			setRankingObject((ranking) => ({
				...ranking,
				sorting: newSorting,
			}));
		} else {
			const newObjectOfSorting = rankingObject.sorting.filter(
				(el) => el.collationId !== target
			);
			setRankingObject((ranking) => ({
				...ranking,
				sorting: newObjectOfSorting,
			}));
		}
	}
	function updapteAttribute(Collation, target) {
		const indexOfItem = rankingObject.sorting.indexOf(Collation);
		function replaceAt(array, index, value) {
			const ret = array.slice(0);
			ret[index] = value;
			return ret;
		}
		const rankingToChange = rankingObject.sorting[indexOfItem];
		if (Math.sign(Collation.weight) === 1) {
			rankingToChange.weight = parseFloat(target);
		}
		else {
			// @ts-ignore
			rankingToChange.weight = parseFloat(- target);
		}
		const newArrayOfSorting = replaceAt(rankingObject.sorting, indexOfItem, rankingToChange);
		setRankingObject((ranking) => ({
			...ranking, sorting: newArrayOfSorting
		}));
	}
	function onChangeAttributeOfSign(Collation) {
		const indexOfItem = rankingObject.sorting.indexOf(Collation);
		function replaceAt(array, index, value) {
			const ret = array.slice(0);
			ret[index] = value;
			return ret;
		}
		const rankingToChange = rankingObject.sorting[indexOfItem];
		if (Math.sign(Collation.weight) === 1) {
			// @ts-ignore
			rankingToChange.weight = parseFloat(-rankingToChange.weight);
		}
		else {
			rankingToChange.weight = Math.abs(rankingToChange.weight);
		}
		const newArrayOfSorting = replaceAt(rankingObject.sorting, indexOfItem, rankingToChange);
		setRankingObject((ranking) => ({
			...ranking, sorting: newArrayOfSorting
		}));
	}
	// Category
	function changeCategorySelected(elem) {
		setloadingProductList(true);
		const nextCategory: any = typeCategories?.find((el: any) => el?.name === elem);
		setCategorySelected(nextCategory);
		setSelectedProducts([]);
		const valueOfSecondCategorySelect = allCategoriesData?.find((el: any) => el.type === nextCategory?.name).knownNames.map(el => ({ name: el, label: el }));
		settypeCategoriesSecondLevel(valueOfSecondCategorySelect);
		setTypeCategoriesSecondLevelSelected(valueOfSecondCategorySelect[0]);
		setneedRefreshPagination(true);
	}
	function changeSecondCategorySelected(elem) {
		const newCategory = typeCategoriesSecondLevel.find(el => el.name === elem);
		if(newCategory){
			setTypeCategoriesSecondLevelSelected(newCategory);
		}else{
			setTypeCategoriesSecondLevelSelected(typeCategoriesSecondLevel[0]);
		}

		setloadingProductList(true);
		setneedRefreshPagination(true);
	}
	const handleSelectCategorySelection = (elem: any) => {
		const nextCategory :any= typeCategories?.find((el:any )=> el?.name === elem.cat1);
		setCategorySelected(nextCategory);
		setSelectedProducts([]);
		const valueOfSecondCategorySelect = allCategoriesData?.find((el: any) => el.type === nextCategory?.name).knownNames.map(el => ({ name: el, label: el }));
		const newCategory = valueOfSecondCategorySelect.find(el => el.name === elem.cat2);
		if (newCategory) {
			setTypeCategoriesSecondLevelSelected(newCategory);
		} else {
			setTypeCategoriesSecondLevelSelected(typeCategoriesSecondLevel[0] || null);
		}
		setloadingProductList(true);
		setneedRefreshPagination(true);
	};
	// Promoted Product & Demoted product
	function changeOrderOfPromotedProduct(elem) {
		setPromotedProducts((productItems) => ({
			...productItems,
			pageItems: Array.isArray(elem) ? [...elem] : elem
		}));
		handleChangeTranformationByPromotedProduct(elem);

	}
	function changeOrderOfDemotedProduct(elem) {
		setDemotedProduct((productItems) => ({
			...productItems,
			pageItems: elem
		}
		));
		handleChangeTranformationByDemotedProduct(elem);
	}
	function handleChangeTranformationByPromotedProduct(items) {
		const newObjectOfTransformationWithoutPromotedProduct = rankingObject.transformations.filter(el => el.collationId !== promoteId);

		const existingPromotedTransformation = rankingObject.transformations.find(el => el.collationId === promoteId);
		let existingPromotedIds = [] as string[];
		if (existingPromotedTransformation) {
			existingPromotedIds = existingPromotedTransformation.params[0].value.stringValues;
		}
		// First take items order
		const newItemIds = items.map(it => it.id);

		const remainingExistingIds = existingPromotedIds.filter(id => !newItemIds.includes(id));
		const orderedIds = [...newItemIds, ...remainingExistingIds];

		const transformationsByPromotedProducts = {
			collationId: promoteId,
			params: [{
				name: 'Product Ids',
				value: {
					stringValues: orderedIds,
				}
			}]
		};

		setRankingObject((rObject) => ({
			...rObject,
			transformations: [...newObjectOfTransformationWithoutPromotedProduct, transformationsByPromotedProducts]
		}));
	}
	function handleChangeTranformationByDemotedProduct(items) {
		const newObjectOfTransformationWithoutDemotedProduct = rankingObject.transformations.filter(el => el.collationId !== demoteId);

		const existingDemotedTransformation = rankingObject.transformations.find(el => el.collationId === demoteId);
		let existingDemotedIds = [];
		if (existingDemotedTransformation) {
			// @ts-ignore
			existingDemotedIds = existingDemotedTransformation.params[0].value.stringValues;
		}

		// First take items order
		const newItemIds = items.map(it => it.id);

		const remainingExistingIds = existingDemotedIds.filter(id => !newItemIds.includes(id));
		const orderedIds = [...newItemIds, ...remainingExistingIds];

		const transformationsByDemotedProducts = {
			collationId: demoteId,
			params: [{
				name: 'Product Ids',
				value: {
					stringValues: orderedIds,
				}
			}]
		};

		setRankingObject((rObject) => ({
			...rObject,
			transformations: [...newObjectOfTransformationWithoutDemotedProduct, transformationsByDemotedProducts]
		}));
	}
	function addPromotedProductManualy(newPromotedproducts) {
		const transformationObjectByPromotedProduct = rankingObject.transformations.find(el => el.collationId === promoteId);
		let myNewArrayOfPromotedProduct = newPromotedproducts.split(/[;,\n]/).filter(x => x.length > 0);
		const oldArray = transformationObjectByPromotedProduct ? transformationObjectByPromotedProduct.params[0].value.stringValues : [];

		myNewArrayOfPromotedProduct = [...oldArray, ...myNewArrayOfPromotedProduct];
		const promoteListN = myNewArrayOfPromotedProduct.reduce((obj, curr) => {
			const elementExistInList = obj.listPromoted.indexOf(curr);

			if (elementExistInList === -1) {
				return obj = {
					listPromoted: [...obj.listPromoted, curr],
					listDuplicate: [...obj.listDuplicate]
				};
			} else {
				return obj = {
					listPromoted: [...obj.listPromoted],
					listDuplicate: [...obj.listDuplicate, curr]
				};
			}
		}, {
			listPromoted: [],
			listDuplicate: []
		});
		myNewArrayOfPromotedProduct = promoteListN.listPromoted;
		setModalManualIsOpen(false);
		function transformationObjectWithoutPromotedProduct() {
			const obj = rankingObject.transformations.filter(el => el.collationId !== promoteId);
			if (obj.length > 0) {
				return obj;
			} else {
				return [];
			}
		}


		function getNewArrayofPromote() {
			if (transformationObjectByPromotedProduct) {
				return ({
					collationId: promoteId,
					params: [{
						name: 'Product Ids',
						value: {
							stringValues: [...myNewArrayOfPromotedProduct]
						}
					},

					]
				});
			} else {
				return ({
					collationId: promoteId,
					params: [{
						name: 'Product Ids',
						value: {
							stringValues: [...myNewArrayOfPromotedProduct]
						}
					},

					]
				});
			}


		}
		const newTransformationObj = [...transformationObjectWithoutPromotedProduct(),
			getNewArrayofPromote()
		];
		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));
		setNeedToLoadPromote(true);
	}
	function addPromotedProductWithId(newPromotedproductsId) {
		function transformationObjectWithoutPromotedProduct() {
			const obj = rankingObject.transformations.filter(el => el.collationId !== promoteId);
			if (obj.length > 0) {
				return obj;
			} else {
				return [];
			}
		}
		const transformationObjectByPromotedProduct = rankingObject.transformations.find(el => el.collationId === promoteId);
		function getNewArrayofPromote() {
			if (transformationObjectByPromotedProduct) {
				const oldArrayOfDemotedProducts = [...transformationObjectByPromotedProduct['params'][0]['value']['stringValues']];

				return ({
					collationId: promoteId,
					params: [{
						name: 'Product Ids',
						value: {
							stringValues: [...oldArrayOfDemotedProducts, newPromotedproductsId]
						}
					},

					]
				});
			} else {
				return ({
					collationId: promoteId,
					params: [{
						name: 'Product Ids',
						value: {
							stringValues: [newPromotedproductsId]
						}
					},

					]
				});
			}
		}
		const newTransformationObj = [...transformationObjectWithoutPromotedProduct(),
			getNewArrayofPromote()
		];

		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));
	}
	function addPromotedProductsWithIds(newPromotedProductsIds: string[]) {
		function transformationObjectWithoutPromotedProduct() {
			const obj = rankingObject.transformations.filter(el => el.collationId !== promoteId);
			return obj.length > 0 ? obj : [];
		}
		const transformationObjectByPromotedProduct = rankingObject.transformations.find(el => el.collationId === promoteId);

		function getNewArrayofPromote() {
			if (transformationObjectByPromotedProduct) {
				const oldArrayOfPromotedProducts = [...transformationObjectByPromotedProduct['params'][0]['value']['stringValues']];
				// Avoid duplicates
				const merged = Array.from(new Set([...oldArrayOfPromotedProducts, ...newPromotedProductsIds]));
				return ({
					collationId: promoteId,
					params: [{
						name: 'Product Ids',
						value: {
							stringValues: merged
						}
					}]
				});
			} else {
				return ({
					collationId: promoteId,
					params: [{
						name: 'Product Ids',
						value: {
							stringValues: [...newPromotedProductsIds]
						}
					}]
				});
			}
		}

		const newTransformationObj = [
			...transformationObjectWithoutPromotedProduct(),
			getNewArrayofPromote()
		];

		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}));
		setSelectedProducts([]);
	}
	function deletePromotedProduct(idsOfProduct) {

		if (idsOfProduct.length === 0) {
			const newArrayWithoutPromote = rankingObject.transformations.filter(el => el.collationId !== promoteId);
			const newTransformationObj = [...newArrayWithoutPromote];
			setRankingObject((rObject) => ({
				...rObject,
				transformations: newTransformationObj
			}
			));
		}
		else {

			// eslint-disable-next-line no-inner-declarations
			function transformationObjectWithoutPromotedProduct() {
				const obj = rankingObject.transformations.filter(el => el.collationId !== promoteId);
				if (obj.length > 0) {
					return obj;
				} else {
					return [];
				}
			}

			const transformationObjectByPromotedProduct = rankingObject.transformations.find(el => el.collationId === promoteId);
			// eslint-disable-next-line no-inner-declarations
			function getNewArrayofPromote() {
				if (transformationObjectByPromotedProduct) {
					return ({
						collationId: promoteId,
						params: [{
							name: 'Product Ids',
							value: {
								'stringValues': [...idsOfProduct]
							}
						},

						]
					});

				} else {
					return ({
						collationId: promoteId,
						params: [{
							name: 'Product Ids',
							value: {
								'stringValues': [...idsOfProduct]
							}
						},

						]
					});
				}


			}
			const newTransformationObj = [...transformationObjectWithoutPromotedProduct(),
				getNewArrayofPromote()
			];
			setRankingObject((rObject) => ({
				...rObject,
				transformations: newTransformationObj
			}
			));
		}

	}
	function transformationObjectWithoutDemotedProduct() {
		const obj = rankingObject.transformations.filter(el => el.collationId !== demoteId);
		if (obj.length > 0) {
			return obj;
		} else {
			return [];
		}
	}
	function addDemotedProductManualy(newDemotedproducts) {
		const transformationObjectByDemotedProduct = rankingObject.transformations.find(el => el.collationId === demoteId);
		let myNewArrayOfDemotedProduct = newDemotedproducts.split(/[;,\n]/).filter(x => x.length > 0);
		const oldArray = transformationObjectByDemotedProduct ? transformationObjectByDemotedProduct.params[0].value.stringValues : [];
		myNewArrayOfDemotedProduct = [...oldArray, ...myNewArrayOfDemotedProduct];
		const demoteListN = myNewArrayOfDemotedProduct.reduce((obj, curr) => {
			const elementExistInList = obj.listPromoted.indexOf(curr);

			if (elementExistInList === -1) {
				return obj = {
					listPromoted: [...obj.listPromoted, curr],
					listDuplicate: [...obj.listDuplicate]
				};
			} else {
				return obj = {
					listPromoted: [...obj.listPromoted],
					listDuplicate: [...obj.listDuplicate, curr]
				};
			}
		}, {
			listPromoted: [],
			listDuplicate: []
		});
		myNewArrayOfDemotedProduct = demoteListN.listPromoted;
		setModalManualIsOpen(false);

		function transformationObjectWithoutDemotedProduct() {
			const obj = rankingObject.transformations.filter(el => el.collationId !== demoteId);
			if (obj.length > 0) {
				return obj;
			} else {
				return [];
			}
		}

		function getNewArrayofDemote() {
			if (transformationObjectByDemotedProduct) {
				return ({
					collationId: demoteId,
					params: [{
						name: 'Product Ids',
						value: {
							'stringValues': [...myNewArrayOfDemotedProduct]
						}
					},

					]
				});
			} else {
				return ({
					collationId: demoteId,
					params: [{
						name: 'Product Ids',
						value: {
							'stringValues': [...myNewArrayOfDemotedProduct]
						}
					},

					]
				});
			}
		}
		const newTransformationObj = [...transformationObjectWithoutDemotedProduct(),
			getNewArrayofDemote()
		];
		setNeedToLoadDemote(true);
		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));

	}
	function addDemotedProductWithId(newDemotedproductsId) {
		const transformationObjectByDemotedProduct = rankingObject.transformations.find(el => el.collationId === demoteId);
		function getNewArrayofDemote() {
			if (transformationObjectByDemotedProduct) {
				const oldArrayOfDemotedProducts = [...transformationObjectByDemotedProduct['params'][0]['value']['stringValues']];

				return ({
					collationId: demoteId,
					params: [{
						name: 'Product Ids',
						value: {
							'stringValues': [...oldArrayOfDemotedProducts, newDemotedproductsId]
						}
					},

					]
				});
			} else {
				return ({
					collationId: demoteId,
					params: [{
						name: 'Product Ids',
						value: {
							'stringValues': [newDemotedproductsId]
						}
					},]
				});
			}
		}
		const newTransformationObj = [...transformationObjectWithoutDemotedProduct(),
			getNewArrayofDemote()
		];
		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));

	}
	function addDemotedProductIds(newDemotedProductIds) {
		const transformationObjectByDemotedProduct = rankingObject.transformations.find(el => el.collationId === demoteId);

		function getNewArrayOfDemote() {
			if (transformationObjectByDemotedProduct) {
				const oldArrayOfDemotedProducts = [...transformationObjectByDemotedProduct['params'][0]['value']['stringValues']];

				return {
					collationId: demoteId,
					params: [{
						name: 'Product Ids',
						value: {
							'stringValues': [...oldArrayOfDemotedProducts, ...newDemotedProductIds]
						}
					}]
				};
			} else {
				return {
					collationId: demoteId,
					params: [{
						name: 'Product Ids',
						value: {
							'stringValues': [...newDemotedProductIds]
						}
					}]
				};
			}
		}

		const newTransformationObj = [
			...transformationObjectWithoutDemotedProduct(),
			getNewArrayOfDemote()
		];

		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}));
		setSelectedProducts([]);
	}
	function deleteDemotedProduct(idsOfProduct) {
		if (idsOfProduct.length === 0) {
			const newArrayWithoutDemote = rankingObject.transformations.filter(el => el.collationId !== demoteId);
			const newTransformationObj = [...newArrayWithoutDemote];
			setRankingObject((rObject) => ({
				...rObject,
				transformations: newTransformationObj
			}));
		}
		else {

			// eslint-disable-next-line no-inner-declarations
			function transformationObjectWithoutDemotedProduct() {
				const obj = rankingObject.transformations.filter(el => el.collationId !== demoteId);
				if (obj.length > 0) {
					return obj;
				} else {
					return [];
				}
			}
			const transformationObjectByDemotedProduct = rankingObject.transformations.find(el => el.collationId === demoteId);
			// eslint-disable-next-line no-inner-declarations
			function getNewArrayofDemote() {
				if (transformationObjectByDemotedProduct) {
					return ({
						collationId: demoteId,
						params: [{
							name: 'Product Ids',
							value: {
								'stringValues': [...idsOfProduct]
							}
						},

						]
					});
				} else {
					return ({
						collationId: demoteId,
						params: [{
							name: 'Product Ids',
							value: {
								'stringValues': [...idsOfProduct]
							}
						},

						]
					});
				}
			}
			const newTransformationObj = [...transformationObjectWithoutDemotedProduct(),
				getNewArrayofDemote()
			];
			setRankingObject((rObject) => ({
				...rObject,
				transformations: newTransformationObj
			}
			));
		}
	}
	// Replace Item
	function deleteReplaceProductItem(idsOfProduct) {
		if (idsOfProduct.length === 0) {
			const newArrayWithoutDemote = rankingObject.transformations.filter(el => el.collationId !== replaceId);
			const newTransformationObj = [...newArrayWithoutDemote];
			setRankingObject((rObject) => ({
				...rObject,
				transformations: newTransformationObj
			}
			));
		} else {
			// Récupérer que les élément Replace sans l'id à delete
			const replaceProductInTransformObj = filterJustByReplaceProduct([...rankingObject.transformations], idsOfProduct);
			// refaire le tableau des transformation avec le nouvel array de Replace
			const newArrayOfTransformations = [...getProductsWhithoutReplaceTransformationObject(rankingObject.transformations), ...replaceProductInTransformObj];
			setRankingObject((rObject) => ({
				...rObject,
				transformations: newArrayOfTransformations
			}
			));
		}
	}
	function addReplaceProductManualy(promotedP) {
		const newReplaceTranformation = {
			collationId: replaceId,
			params: [{
				name: 'First Product Id',
				value: {
					stringValues: [promotedP.replaceId],
				}
			},
			{
				name: 'Second Product Id',
				value: {
					stringValues: [promotedP.toReplaceId],
				}
			}
			]
		};
		const newTransformationObj = [...rankingObject.transformations,
			newReplaceTranformation
		];
		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));
	}
	function addReplaceProductWithId(promotedP) {
		const newReplaceTranformation = {
			collationId: replaceId,
			params: [{
				name: 'First Product Id',
				value: {
					stringValues: [promotedP.replaceId],
				}
			},
			{
				name: 'Second Product Id',
				value: {
					stringValues: [promotedP.toReplaceId],
				}
			}
			]
		};
		const newTransformationObj = [...rankingObject.transformations,
			newReplaceTranformation
		];
		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));
	}
	function addReplaceProductWithIds(ids) {
		const newReplaceTranformation = {
			collationId: replaceId,
			params: [{
				name: 'First Product Id',
				value: {
					stringValues: [ids[0]],
				}
			},
			{
				name: 'Second Product Id',
				value: {
					stringValues: [ids[1]],
				}
			}
			]
		};
		const newTransformationObj = [...rankingObject.transformations,
			newReplaceTranformation
		];
		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));
		setSelectedProducts([]);
	}
	function removeCollectionById(data, id) {
		return data.filter(item => {
			return !item.params.some(param => {
				return param.value.stringValues && param.value.stringValues.includes(id);
			});
		});
	}
	function deleteReplaceProductWithId(idOfProduct) {
		const collectionReplace = rankingObject.transformations.filter(el => el.collationId === replaceId);
		const updatedData = removeCollectionById(collectionReplace, idOfProduct);
		const newTransformationObj = [...getProductsWhithoutReplaceTransformationObject(rankingObject.transformations), ...updatedData];

		setRankingObject((rObject) => ({
			...rObject,
			transformations: newTransformationObj
		}
		));
	}
	
	const deletePinnedProductWithId = (idOfProduct) => {
		if (!selectedCategoryIsShopifyCollection.isPinnableShopifyCollection || selectedCategoryIsShopifyCollection.collectionId === undefined) 
			return;
		shopifyCollectionPinnedProductsService.handleDeleteProductPositionById(selectedCategoryIsShopifyCollection.collectionId, 
			idOfProduct
		);
	};

	const applyManualTransformations = (promoteIds, demoteIds, replaceIds) => {
		let newTransformations = [...rankingObject.transformations];

		// Handle promoteIds
		const existingPromoteTransformationIndex = newTransformations.findIndex(
			transformation => transformation.collationId === promoteId
		);

		if (promoteIds.length === 0 && existingPromoteTransformationIndex !== -1) {
			newTransformations.splice(existingPromoteTransformationIndex, 1);
		} else if (promoteIds.length > 0) {
			if (existingPromoteTransformationIndex !== -1) {
				newTransformations[existingPromoteTransformationIndex].params[0].value.stringValues = promoteIds;
			} else {
				newTransformations.push({
					collationId: promoteId,
					params: [{ name: 'Product Ids', value: { stringValues: promoteIds } }]
				});
			}
		}

		// Handle demoteIds
		const existingDemoteTransformationIndex = newTransformations.findIndex(
			transformation => transformation.collationId === demoteId
		);

		if (demoteIds.length === 0 && existingDemoteTransformationIndex !== -1) {
			newTransformations.splice(existingDemoteTransformationIndex, 1);
		} else if (demoteIds.length > 0) {
			if (existingDemoteTransformationIndex !== -1) {
				newTransformations[existingDemoteTransformationIndex].params[0].value.stringValues = demoteIds;
			} else {
				newTransformations.push({
					collationId: demoteId,
					params: [{ name: 'Product Ids', value: { stringValues: demoteIds } }]
				});
			}
		}

		// Handle replaceIds
		if (replaceIds.length > 0) {
			newTransformations = newTransformations.filter(
				transformation => transformation.collationId !== replaceId);
			newTransformations.push(...replaceIds);
		} else {
			newTransformations = newTransformations.filter(
				transformation => transformation.collationId !== replaceId);
		}

		setRankingObject(prevRankingObject => ({
			...prevRankingObject,
			transformations: newTransformations
		}));

	};

	const getSelectedTenant = (): string | undefined => {
		if (rankingObject?.tenant === null || rankingObject.tenant === 'All') {
			if (previewTenant && previewTenant.value === 'all') {
				return undefined;
			} else if (previewTenant && previewTenant.value !== 'all') {
				return previewTenant.value;
			}
		} else {
			return rankingObject.tenant;
		}
	};

	const searchProductsByIds = (ids: string[], callbackSuccess, callbackError?) => {
		searchProducts({
			ids: [...ids],
			limit: 540,
		}, callbackSuccess, callbackError);
	};

	const searchProductsByTerm = (searchTerms, callbackSuccess, callbackError?) => {
		searchProducts({
			searchTerm: searchTerms,
			limit: 540,
		}, callbackSuccess, callbackError);
	};

	const searchProducts = (search: SearchRequest, callbackSuccess, callbackError?) => {
		const needTenantForSearch = tenantsCatalog.length > 1;
		if (needTenantForSearch) {
			searchProductFeed.postSearchWithTenant(
				{
					...search,
					requestedFields: search.requestedFields ?? [ProductFields.NameThumbnailAndCategories]
				},
				getSelectedTenant() ?? '',
				callbackSuccess,
				callbackError ?? ((e) => console.log('Error fetching products:' + e))
			);
		} else {
			searchProductFeed.postSearchEmptyTenant(
				{
					...search,
					requestedFields: search.requestedFields ?? [ProductFields.NameThumbnailAndCategories]
				},
				callbackSuccess,
				callbackError ?? ((e) => console.log('Error fetching products:' + e))
			);
		}
	};

	return (
		<RankingContext.Provider
			value={{
				errorNoConfiguration,
				deviceType,
				changeDeviceSelected,
				accountWithoutCategories,
				idInClipBoard,
				copyToClipBoard,
				loadingSaving,
				checkIfCanQuitWithoutSave,
				modalConfirmIsOpen,
				returnToDashboard,
				handleCloseConfirm,
				modalCancelActions,
				addReplaceProductWithIds,
				cancelActions,
				handleCloseCancelActions,
				returnToFirstStateOfRanking,
				handleChangeTenantPreview,
				previewTenant,
				// config mode
				mode,

				tenantsCatalog,
				// ranking object
				ruleName,
				rankingObject,
				handleChangeRankingName,
				handleChangeRankingDescription,
				descriptionRule,
				handleChangeTenant,
				listTenantAccount,
				// filters
				ListFilter,
				handeChangeFilterSorting,
				updapteAttribute,
				removeAttribute,
				onChangeAttributeOfSign,
				onRemoveGroupSorting,
				onSetGroupSorting,
				getCheckIfIsAValidUrlFetch,
				needToLoadPromote,
				setNeedToLoadPromote,
				needToLoadDemote,
				setNeedToLoadDemote,
				selectedProducts,
				setSelectedProducts,
				// list
				productList,
				modalManualSorting,
				setModalManualIsOpen,
				categorySelected,
				typeCategories,
				changeCategorySelected,
				handleSelectCategorySelection,
				typeCategoriesSecondLevel,
				typeCategoriesSecondLevelSelected,
				changeSecondCategorySelected,
				promotedProducts,
				demotedProduct,
				changeOrderOfPromotedProduct,
				changeOrderOfDemotedProduct,
				loadingProductList,
				addPromotedProductManualy,
				deletePromotedProduct,
				addDemotedProductManualy,
				deleteDemotedProduct,
				replaceProducts,
				deleteReplaceProductItem,
				addReplaceProductManualy,
				addPromotedProductWithId,
				addPromotedProductsWithIds,
				addDemotedProductWithId,
				addDemotedProductIds,
				addReplaceProductWithId,
				applyManualTransformations,
				localArrayOfProductIdSwap,
				setLocalArrayOfProductIdSwap,
				//pagination
				paginationOptions,
				handleChangePaginationOptions,
				currentPageProductList,
				setCurrentPageProductList,
				setNewPaginationNeed,
				// API
				CreateRanking,
				PutRankingById,
				handleChangeSortingFactors,
				accountId,
				setupAccountServices,
				searchProductFeed,
				arrayOfValuetags,
				needToLoadSwap,
				setNeedToLoadSwap,
				isSwapList,
				setIsSwapList,
				searchProductsByIds,
				searchProductsByTerm,
				searchProducts,
				canUseShopifyManualSorting,
				shopifyCollectionWithPinnedProducts,
				shopifyPinnedProductsOfSelectedCategory,
				hasRetrievedNoShopifyCollection,
				shopifyCollections,
				selectedCategoryIsShopifyCollection,
				shopifyCollectionPinnedProductsService,
				deleteReplaceProductWithId,
				deletePinnedProductWithId
			}}
		>
			{props.children}
		</RankingContext.Provider>
	);
};

export default CreateRankingContextProvider;

export { useRankingContext };
